export const smPixel = (pixel: number) => `${pixel * 0.62}px`;
export const mdPixel = (pixel: number) => `${pixel * 0.75}px`;
export const lgPixel = (pixel: number) => `${pixel * 0.66}px`;
export const xlPixel = (pixel: number) => `${pixel}px`;
